import React, { useEffect } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement);

const DoughnutChart = ({ chartData }) => {
  const total = chartData.count_exercises;
  const [doughNutData, setDoughNutData] = React.useState([]);
  const [doughNutColors, setDoughNutColors] = React.useState([]);
  useEffect(() => {
    chartData.exercise_category_stats_list.forEach((element) => {
      setDoughNutData((prev) => [...prev, element.count]);
      setDoughNutColors((prev) => [...prev, element.color_code]);
    });
  }, []);

  const centerText = {
   id:'centerText',
   afterDatasetsDraw(chart, args, pluginOptions) {
      const { ctx } = chart;
      // add text in the center
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      // add font size to canvas element
      ctx.font = "500 18px Poppins";
      ctx.fillText("Total", 100, 70);
      ctx.fillText("Exercise", 100, 90);
      ctx.font = "600 36px Poppins";
      ctx.fillText(total, 100, 130);
   }
  };
  const data = {
    datasets: [
      {
        data: doughNutData,
        backgroundColor: doughNutColors,
        // reduce the radius of the pie chart
      },
    ],
  };
  const options={
    cutout: "60%",
  }

  return (
    <div className="flex justify-evenly w-full items-center">
      <div className="w-[210px] h-[200px]">
        <Doughnut data={data} plugins={[centerText]} options={options} />
      </div>
      <div>
        <table>
          <tbody>
            {chartData.exercise_category_stats_list.map((item, index) => {
              return (
                <tr key={index}>
                  <td className="w-7 h-3 rounded-sm mr-3">
                    <div
                      className="w-7 h-3 rounded-sm mr-3"
                      style={{
                        backgroundColor: item.color_code,
                      }}
                    ></div>
                  </td>
                  <td className="mr-4">{item.display_name}</td>
                  <td className="pl-5">{item.count}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DoughnutChart;
